import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, ApplicationRef } from '@angular/core';
import { Project } from '@src/app/models/project';
import { ProjectTimeSummaryRow } from '@src/app/models/projecttimesummary';
import { formatMinutesAsHours } from '@src/app/helpers/timeregistration/hours.util';

@Component({
  selector: 'app-projectcard',
  templateUrl: './projectcard.component.html',
  styleUrl: './projectcard.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectcardComponent {

  @Input() project: Project;
  @Input() filterTxt: string;
  @Input() showDisabled: boolean;
  @Input() customerportal: boolean;
  @Input() pnewidth: number;
  @Input() showFilter: boolean;
  @Input() orgedit: boolean;
  @Input() organizationId: string;
  @Input() customerId: string;
  @Input() timeregEnabled: boolean;
  @Input() timeSummary: ProjectTimeSummaryRow;
  @Input() showStartYear = false;
  @Input() showEndYear = false;

  @Output() clickWork = new EventEmitter<Project>();
  @Output() clickEdit = new EventEmitter<Project>();
  @Output() clickAssign = new EventEmitter<Project>();
  @Output() clickDelete = new EventEmitter<Project>();
  @Output() clikcDisable = new EventEmitter<Project>();
  @Output() clickTemplate = new EventEmitter<Project>();
  @Output() clickAutomation = new EventEmitter<Project>();

  gaugeExpanded = false;

  constructor(private cd: ChangeDetectorRef, private appRef: ApplicationRef) { }

  onGaugeExpandedChange(expanded: boolean): void {
    this.gaugeExpanded = expanded;
    this.cd.markForCheck();
    this.appRef.tick();
  }

  // "1/2,5" — logged over estimated across the whole project, only once
  // there's something estimated to show.
  timeCounterLabel(): string | null {
    if (!this.timeSummary || !this.timeSummary.estimateMinutes) {
      return null;
    }
    return formatMinutesAsHours(this.timeSummary.loggedMinutes, ',') + '/' + formatMinutesAsHours(this.timeSummary.estimateMinutes, ',');
  }

  timeCounterTooltip(): string {
    return formatMinutesAsHours(this.timeSummary.loggedMinutes, ',') + ' h logged / '
      + formatMinutesAsHours(this.timeSummary.estimateMinutes, ',') + ' h estimated';
  }

}